import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//component ui:
import DatePicker from '../components/utils/DatePicker';
//material ui:
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Button, Grid } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import Fade from '@material-ui/core/Fade';
import Input from '@material-ui/core/Input';

//actions:
import { getData, createReport } from '../dataLib';
import { openDialog, hideDialog } from '../actions/index';
import { setCentroDia } from '../actions/centro_dia_actions';

const styles = theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    centroSelect: {
        maxWidth: 240,
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: 10,
    },
    button: {
        margin: '15px 8px',
        padding: '10px',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        width: 150,
    },
    buttonCerrar: {
        padding: '10px',
        margin: '20px 8px 10px',
        width: 100,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    spinnerContainer: {
        width: 250,
        height: 220,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
    linearSpinner: {
        height: 10,
        width: 480,
        marginTop: 10,
        marginLeft: 10,
    },
    tooltip: {
        fontSize: 14,
        color: 'white',
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class ReportRankingMaquinas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            report: {},
            values: {
                monthIni: 1,
                monthEnd: 1,
                yearIni: 2019,
                yearEnd: 2019,
                centroId:
                    this.props.centroDiaSelected.dia !== ''
                        ? this.props.centroDiaSelected.centro.id
                        : 1,
                iniDate:
                    this.props.centroDiaSelected.dia !== ''
                        ? this.props.centroDiaSelected.dia
                        : null,
                endDate:
                    this.props.centroDiaSelected.dia !== ''
                        ? this.props.centroDiaSelected.dia
                        : null,
                wIniDate:
                    this.props.centroDiaSelected.dia !== ''
                        ? this.props.centroDiaSelected.dia
                        : null,
                wEndDate:
                    this.props.centroDiaSelected.dia !== ''
                        ? this.props.centroDiaSelected.dia
                        : null,
                maquinaId: -100,
                modeloId: -100,
                chk1: false,
                chk2: false,
                chk3: false,
                chk4: false,
                chk5: false,
                opt1: '1',
                opt2: '1',
                dw: 1,
                ids: [],
                page: -1,
            },
            modelos: [],
            maquinas: [],
            loaded: false,
            pdfLoading: false,
            centroDiaCierre: 1,
        };

        this.reportId = 27;
    }

    componentDidMount() {
        this.getReportDefinition();
        this.getModelos();
        this.getMaquinas(this.state.values.centroId);
    }

    // componentDidUpdate(prevProps) {
    //     if (prevProps.centros !== this.props.centros && this.props.centros.length > 0) {
    //         this.getMaquinas(this.props.centros[0].id);
    //     }
    // };

    getReportDefinition = () => {
        getData(
            'NaReport/' + this.reportId,
            response => {
                this.setState({
                    ...this.state,
                    report: response.data,
                    loaded: true,
                });
            },
            () => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR fetching report definition',
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
            },
            this.props.user,
        );
    };

    compareDescr = (a, b) => {
        if (a.descr.toLowerCase() < b.descr.toLowerCase()) return -1;
        if (a.descr.toLowerCase() > b.descr.toLowerCase()) return 1;
        return 0;
    };

    getModelos = () => {
        getData(
            'VModeloMaquinas',
            response => {
                this.setState({
                    ...this.state,
                    modelos: [...response.data].sort(this.compareDescr),
                });
            },
            () => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR fetching modelos',
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
            },
            this.props.user,
        );
    };

    getMaquinas = centroId => {
        //maquines del centro

        getData(
            'VMaquinas/VMaquinasAlta?centro_id=' + centroId,
            response => {
                this.setState({
                    ...this.state,
                    maquinas: [...response.data].sort(this.compareDescr),
                });
            },
            () => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR fetching maquinas',
                    },
                    uuidv4(),
                    false,
                    'sm',
                );
            },
            this.props.user,
        );
    };

    handleValueChange = (event, field) => {
        const newValues = { ...this.state.values, [field]: event.target.value };
        this.setState({ ...this.state, values: newValues });
    };

    handleSelectCentrosValueChange = event => {
        var centroSelected = this.props.centros.find(
            c => c.id === Number(event.target.value),
        );
        if (centroSelected !== undefined) {
            const newValues = {
                ...this.state.values,
                centroId: event.target.value,
            };
            this.setState({
                ...this.state,
                values: newValues,
                centroDiaCierre: centroSelected.iDiaCierre,
            });
            this.getMaquinas(event.target.value);
            this.props.setCentroDia(
                centroSelected.id,
                this.props.centroDiaSelected.dia,
                false,
            );
        }
    };

    handleCheckboxChange = (event, field) => {
        const newValues = {
            ...this.state.values,
            [field]: event.target.checked,
        };
        this.setState({ ...this.state, values: newValues });
    };

    renderIniDateTime = () => {
        if (this.state.report.dateIni) {
            const { classes } = this.props;
            return (
                <FormControl className={classes.formControl}>
                    <DatePicker
                        label="Fecha inicial"
                        value={this.state.values.iniDate}
                        className={classes.textField}
                        onChange={event => {
                            if (event && !isNaN(event)) {
                                const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                const newValues = {
                                    ...this.state.values,
                                    iniDate: d.toISOString().slice(0, 10),
                                };
                                this.setState({ ...this.state, values: newValues });
                            }
                        }}
                    />
                </FormControl>
            );
        }
    };

    renderEndDateTime = () => {
        if (this.state.report.dateEnd) {
            const { classes } = this.props;
            return (
                <FormControl className={classes.formControl}>
                    <DatePicker
                        label="Fecha final"
                        value={this.state.values.endDate}
                        className={classes.textField}
                        onChange={event => {
                            if (event && !isNaN(event)) {
                                const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                const newValues = {
                                    ...this.state.values,
                                    endDate: d.toISOString().slice(0, 10),
                                };
                                this.setState({ ...this.state, values: newValues });
                            }
                        }}
                    />
                </FormControl>
            );
        }
    };

    renderCheckBox = field => {
        if (this.state.report[field]) {
            return (
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={this.state.values[field]}
                            onChange={event =>
                                this.handleCheckboxChange(event, field)
                            }
                            color="primary"
                        />
                    }
                    label={this.state.report[field]}
                />
            );
        }
    };

    renderSelectCentros = () => {
        const perfil = this.props.userProfile.selectedCentroProfile.iPerfil;

        const centros = ([0, 4, 5, 16, 17, 20].includes(perfil) && this.props.userProfile.selectedCentroProfile.centroId === 10)
            ? this.props.centros.filter(
                c => c.esCasino === this.state.values.chk1 && c.activo === 1,
            )
            : this.props.centros.filter(
                c =>
                    c.id ===
                    this.props.userProfile.selectedCentroProfile.centroId,
            );

        if (this.state.report.centroId) {
            const { classes } = this.props;
            return (
                <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="input-centros">Centro</InputLabel>
                    <Select
                        className={classes.centroSelect}
                        native
                        value={this.state.values.centroId}
                        onChange={event =>
                            this.handleSelectCentrosValueChange(event)
                        }
                        input={<Input id="input-centros" />}
                        name="centroId"
                    >
                        {centros.map(centro => {
                            return (
                                <option
                                    key={'centro_' + centro.id}
                                    value={centro.id}
                                >
                                    {centro.centro}
                                </option>
                            );
                        })}
                    </Select>
                </FormControl>
            );
        }
    };

    renderSelectMaquinas = () => {
        //maquines del centro
        if (this.state.report.maquina) {
            const { classes } = this.props;
            return (
                <div hidden={this.state.values.opt1 === '2'}>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="input-maquina">Maquina</InputLabel>
                        <Select
                            native
                            value={this.state.values.maquinaId}
                            onChange={event =>
                                this.handleValueChange(event, 'maquinaId')
                            }
                            input={<Input id="input-maquina" />}
                            name="maquinaId"
                            disabled={this.state.values.opt1 === '2'}
                        >
                            <option key={'maquina_todos'} value={-100}>
                                Todas
                            </option>
                            {this.state.maquinas.map(maquina => {
                                return (
                                    <option
                                        key={'maquina_' + maquina.id}
                                        value={maquina.id}
                                    >
                                        {maquina.descr}
                                    </option>
                                );
                            })}
                        </Select>
                    </FormControl>
                </div>
            );
        }
    };

    renderSelectModelos = () => {
        if (this.state.report.modelo) {
            const { classes } = this.props;
            return (
                <div hidden={this.state.values.opt1 === '1'}>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="input-modelo">Modelo</InputLabel>
                        <Select
                            native
                            value={this.state.values.modeloId}
                            onChange={event =>
                                this.handleValueChange(event, 'modeloId')
                            }
                            input={<Input id="input-modelo" />}
                            name="modeloId"
                            disabled={this.state.values.opt1 === '1'}
                        >
                            <option key={'modelo_todos'} value={-100}>
                                Todos
                            </option>
                            {this.state.modelos.map(modelo => {
                                return (
                                    <option
                                        key={'modelo_' + modelo.id}
                                        value={modelo.id}
                                    >
                                        {modelo.descr}
                                    </option>
                                );
                            })}
                        </Select>
                    </FormControl>
                </div>
            );
        }
    };

    renderOptionList1 = () => {
        return this.state.report.opt1.split(';').map((o, index) => {
            return (
                <FormControlLabel
                    key={index}
                    value={(index + 1).toString()}
                    control={<Radio />}
                    label={o}
                />
            );
        });
    };

    renderOptionList2 = () => {
        return this.state.report.opt2.split(';').map((o, index) => {
            return (
                <FormControlLabel
                    key={index}
                    value={(index + 1).toString()}
                    control={<Radio />}
                    label={o}
                />
            );
        });
    };

    renderOption1 = () => {
        if (
            this.state.report.opt1 !== undefined &&
            this.state.report.opt1 !== null
        ) {
            const { classes } = this.props;
            return (
                <FormControl
                    component="fieldset"
                    className={classes.formControl}
                    variant="outlined"
                >
                    <RadioGroup
                        aria-label="Option 1"
                        name="opt1"
                        className={classes.group}
                        value={this.state.values.opt1}
                        onChange={event =>
                            this.handleValueChange(event, 'opt1')
                        }
                    >
                        {this.renderOptionList1()}
                    </RadioGroup>
                </FormControl>
            );
        }
    };

    renderOption2 = () => {
        if (
            this.state.report.opt2 !== undefined &&
            this.state.report.opt2 !== null
        ) {
            const { classes } = this.props;
            return (
                <FormControl
                    component="fieldset"
                    className={classes.formControl}
                    variant="outlined"
                >
                    <RadioGroup
                        aria-label="Option 2"
                        name="opt2"
                        className={classes.group}
                        value={this.state.values.opt2}
                        onChange={event =>
                            this.handleValueChange(event, 'opt2')
                        }
                    >
                        {this.renderOptionList2()}
                    </RadioGroup>
                </FormControl>
            );
        }
    };

    viewPDF = reportValues => {
        const suffix = this.props.hasIdList ? '/IdListReport' : '';

        const win = window.open(
            process.env.PUBLIC_URL + '/loading_report.html',
            '_blank',
        );

        let url = '';

        createReport(reportValues, 'PDF', this.props.user, suffix)
            .then(response => {
                url = window.URL.createObjectURL(
                    new Blob([response.data], { type: 'application/pdf' }),
                );
                //window.open(url, '_blank');
                win.location.href = url;
            })
            .catch(error => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: error.response.status == 401 ? error.response.data : 'ERROR generating PDF',
                    },
                    uuidv4(),
                    false,
                    false,
                );
            })
            .then(() => {
                this.setState({ ...this.state, pdfLoading: false });
            });
    };

    downloadPDF = reportValues => {
        const suffix = this.props.hasIdList ? '/IdListReport' : '';

        createReport(reportValues, 'PDF', this.props.user, suffix)
            .then(response => {
                const url = window.URL.createObjectURL(
                    new Blob([response.data]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    'report_' +
                    reportValues.reportDefinition.descr.replace(
                        / /gi,
                        '_',
                    ) +
                    '.pdf',
                );
                document.body.appendChild(link);
                link.click();
            })
            .catch(error => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: error.response.status == 401 ? error.response.data : 'ERROR generating PDF',
                    },
                    uuidv4(),
                    false,
                    false,
                );
            })
            .then(() => {
                this.setState({ ...this.state, pdfLoading: false });
            });
    };

    downloadExcel = reportValues => {
        const suffix = this.props.hasIdList ? '/IdListReport' : '';

        createReport(reportValues, 'EXCEL', this.props.user, suffix)
            .then(response => {
                const url = window.URL.createObjectURL(
                    new Blob([response.data]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    'report_' +
                    reportValues.reportDefinition.descr.replace(
                        / /gi,
                        '_',
                    ) +
                    '.xls',
                );
                document.body.appendChild(link);
                link.click();
            })
            .catch(error => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: error.response.status == 401 ? error.response.data : 'ERROR generating PDF',
                    },
                    uuidv4(),
                    false,
                    false,
                );
            })
            .then(() => {
                this.setState({ ...this.state, pdfLoading: false });
            });
    };

    renderDates = () => {
        return (
            <Grid container spacing={16}>
                <Grid item xs={6}>
                    {this.renderIniDateTime()}
                </Grid>
                <Grid item xs={6}>
                    {this.renderEndDateTime()}
                </Grid>
            </Grid>
        );
    };

    renderOptions = () => {
        return (
            <Grid container spacing={16}>
                <Grid item xs={6}>
                    {this.renderOption1()}
                </Grid>
                <Grid item xs={6}>
                    {this.renderOption2()}
                </Grid>
            </Grid>
        );
    };

    handleCentroSelection = rows => {
        const newValues = {
            ...this.state.values,
            ids: rows.map(
                i => this.props.centros.filter(c => c.isGroup === false)[i].id,
            ),
        };
        this.setState({ ...this.state, values: newValues });
    };

    handlePageValueChange = event => {
        const newValues = { ...this.state.values, page: event.target.value };
        this.setState({ ...this.state, values: newValues });
    };

    renderPagesOptions = files => {
        return files.map((file, index) => {
            return (
                <MenuItem key={index} value={index}>
                    {index + 1}
                </MenuItem>
            );
        });
    };

    renderPageSelector = () => {
        const files = this.state.report.reportFile.split('|');

        if (files.length > 1) {
            const { classes } = this.props;
            return (
                <FormControl className={classes.formControl}>
                    <InputLabel>{'Página'}</InputLabel>
                    <Select
                        value={this.state.values.page}
                        onChange={event => this.handlePageValueChange(event)}
                        name={'page'}
                    >
                        <MenuItem key={-1} value={-1}>
                            Todas
                        </MenuItem>
                        {this.renderPagesOptions(files)}
                    </Select>
                </FormControl>
            );
        }
    };

    handleCheckboxCasinoChange = event => {
        const id = this.props.centros.filter(
            c => c.esCasino === event.target.checked,
        )[0].id;

        this.getMaquinas(id);

        const newValues = {
            ...this.state.values,
            chk1: event.target.checked,
            centroId: id,
        };
        this.setState({ ...this.state, values: newValues });
    };

    renderEsCasinoCheckBox = () => {
        //this.props.userProfile.selectedCentroProfile.centroId

        const perfil = this.props.userProfile.selectedCentroProfile.iPerfil;

        return (

            ([0, 4, 5, 16, 17, 20].includes(perfil) && this.props.userProfile.selectedCentroProfile.centroId === 10) ?

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={this.state.values.chk1}
                            onChange={event =>
                                this.handleCheckboxCasinoChange(event)
                            }
                            color="primary"
                        />
                    }
                    label={'Es casino?'}
                />
                : ''

        );
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                {this.state.loaded ? (
                    <div>
                        <div>
                            {this.props.isDialog ? (
                                <Typography
                                    variant="h6"
                                    style={{ margin: '10px 8px' }}
                                    color={'primary'}
                                >
                                    {this.state.report.descr}
                                </Typography>
                            ) : (
                                    ''
                                )}

                            <Grid container spacing={16}>
                                <Grid item xs={6}>
                                    {this.renderSelectCentros()}
                                </Grid>
                                <Grid item xs={6}>
                                    {this.renderEsCasinoCheckBox()}
                                </Grid>
                            </Grid>

                            {this.renderDates()}
                            {this.renderOptions()}
                            {this.renderSelectMaquinas()}
                            {this.renderSelectModelos()}
                            {this.renderPageSelector()}

                            <div>
                                <Tooltip
                                    title="Ver PDF (permite descarga posterior)"
                                    TransitionComponent={Fade}
                                    TransitionProps={{ timeout: 600 }}
                                    classes={{
                                        tooltip: this.props.classes.tooltip,
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={classes.button}
                                        onClick={() => {
                                            const reportValues = {
                                                reportDefinition: this.state
                                                    .report,
                                                values: this.state.values,
                                            };
                                            this.setState({
                                                ...this.state,
                                                pdfLoading: true,
                                            });
                                            this.viewPDF(reportValues);
                                        }}
                                    >
                                        Abrir PDF
                                    </Button>
                                </Tooltip>
                                <Tooltip
                                    title="Descarga pdf sin visualizar previamente"
                                    TransitionComponent={Fade}
                                    TransitionProps={{ timeout: 600 }}
                                    classes={{
                                        tooltip: this.props.classes.tooltip,
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={classes.button}
                                        onClick={() => {
                                            const reportValues = {
                                                reportDefinition: this.state.report,
                                                values: this.state.values,
                                            };
                                            this.setState({
                                                ...this.state,
                                                pdfLoading: true,
                                            });
                                            this.downloadPDF(reportValues);
                                        }}
                                    >
                                        Descargar PDF
                                    </Button>
                                </Tooltip>
                                <Tooltip
                                    title="Vista rápida de datos en tabla"
                                    TransitionComponent={Fade}
                                    TransitionProps={{ timeout: 600 }}
                                    classes={{
                                        tooltip: this.props.classes.tooltip,
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={classes.button}
                                        onClick={() => {
                                            const reportValues = {
                                                reportDefinition: this.state.report,
                                                values: this.state.values,
                                            };
                                            this.props.openDialog('ReportDataGrid', { reportValues: reportValues }, 'report-data-grid', false, 'lg');
                                        }}
                                    >
                                        Tabla rápida
                                    </Button>
                                </Tooltip>
                                <Tooltip
                                    title="Descarga en hoja excel"
                                    TransitionComponent={Fade}
                                    TransitionProps={{ timeout: 600 }}
                                    classes={{
                                        tooltip: this.props.classes.tooltip,
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={classes.button}
                                        onClick={() => {
                                            const reportValues = {
                                                reportDefinition: this.state
                                                    .report,
                                                values: this.state.values,
                                            };
                                            this.setState({
                                                ...this.state,
                                                pdfLoading: true,
                                            });
                                            this.downloadExcel(reportValues);
                                        }}
                                    >
                                        Descargar Excel
                                    </Button>
                                </Tooltip>
                            </div>
                        </div>
                        {this.state.pdfLoading ? (
                            <LinearProgress
                                className={classes.linearSpinner}
                                variant="indeterminate"
                            />
                        ) : (
                                ''
                            )}

                        {this.props.isDialog ? (
                            <Button
                                className={classes.buttonCerrar}
                                variant="contained"
                                color="secondary"
                                onClick={() => this.props.hideDialog()}
                            >
                                Cerrar
                            </Button>
                        ) : (
                                ''
                            )}
                    </div>
                ) : (
                        <div className={classes.spinnerContainer}>
                            <CircularProgress
                                className={classes.spinner}
                                color="primary"
                            />
                        </div>
                    )}
            </div>
        );
    }
}

ReportRankingMaquinas.propTypes = {
    //state:
    centroDiaSelected: PropTypes.object.isRequired,
    centros: PropTypes.array,
    user: PropTypes.object.isRequired,
    //dispatch:
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    //params:
    hasIdList: PropTypes.bool,
};

function mapStateToProps(state) {
    return {
        centroDiaSelected: state.centroDiaSelected,
        centros: state.centros.centros,
        user: state.oidc.user,
        userProfile: state.userProfile,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            openDialog,
            hideDialog,
            setCentroDia,
        },
        dispatch,
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(ReportRankingMaquinas));
